import { useDebounce, useWindowSize } from '@uidotdev/usehooks';

const useIsMobile = () => {
  const { width } = useWindowSize();
  const debouncedWindowWidth = useDebounce(width, 300);
  return debouncedWindowWidth && debouncedWindowWidth < 1024;
};

export default useIsMobile;
